module.exports = __webpack_public_path__ + "media/images/emblems/Aefligen-coat_of_arms-337c536a0ff92c824a012c783197e5cc.svg";